export const BUTTON_SUPERTITLE = 'View'
export const SLM_TITLE = 'Streaming Lesson Media'
export const SCRIPT_TITLE = 'Lesson Script'
export const ACTIVITIES_TITLE = 'Daily Activities'
export const BB_PREP_VIDEO_TITLE = 'Brain Builder Prep Videos'
